export default {
    getList: {
        getSiteList: async function (params) {
            let option = {
                url: '/api/v1/worksheet/sites',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.userNoticeList.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        getAlertList: async function (params) {
            let option = {
                url: '/api/v1/worksheet/alerts',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.userNoticeList.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        creat: async function (params) {
            let option = {
                url: '/api/v1/worksheet/create',
                type: 'post',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.userNoticeList.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        upload: async function (params) {
            let option = {
                url: '/api/v1/worksheet/preupload',
                type: 'postFile',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.userNoticeList.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        getFileList: async function (params) {
            let option = {
                url: '/api/v1/worksheet/uploadfile',
                type: 'post',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.userNoticeList.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        getSelectItem: async function (params) {
            let option = {
                url: '/api/v1/worksheet/selectfile',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminProcessWorkList.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
    }
}